import { create } from "zustand";

interface LoginModal {
    isLoginModalOpen: boolean;
    openLoginModal: () => void;
    closeLoginModal: () => void;
    toggleLoginModal: () => void;
}

export const useLoginModal = create<LoginModal>()((set) => ({
    isLoginModalOpen: false,
    openLoginModal: () => set({ isLoginModalOpen: true }),
    closeLoginModal: () => set({ isLoginModalOpen: false }),
    toggleLoginModal: () =>
        set((state) => ({ isLoginModalOpen: !state.isLoginModalOpen })),
}));
